import { PurchaseOrderLinks, type ExtendedReferencedVendor } from "@finway-group/shared/lib/models"
import { type DeliveryNote as DeliveryNoteShared } from "@finway-group/shared/lib/models/deliveryNote/deliveryNote.model"
import moment from "moment"

export interface DeliveryNote extends DeliveryNoteShared<string> {}

export type DeliveryNoteFormValues = Pick<DeliveryNote, "deliveryNoteNumber" | "description" | "lineItems" | "deliveryNoteDocument"> & {
    vendor: ExtendedReferencedVendor
    dateOfIssue: moment.Moment
    dateOfIssueForm: moment.Moment
    deliveryLocation: string
}

export type DeliveryNoteTableColumn = Pick<DeliveryNote, "dateOfIssue" | "createdBy"> & {
    key: string
    name: string
    vendor: string
    linkedTo: Array<string>
}

export type DeliveryNoteForLinking = PurchaseOrderLinks<string>["deliveryNotes"][number]

export const DeliveryNoteStatusEnum = {
    DELIVERY_NOTE_DOCUMENT_PENDING: "DELIVERY_NOTE_DOCUMENT_PENDING",
    DELIVERY_NOTE_DOCUMENT_SUCCESS: "DELIVERY_NOTE_DOCUMENT_SUCCESS",
    DELIVERY_NOTE_PARTIALLY_LINKED: "DELIVERY_NOTE_PARTIALLY_LINKED",
    DELIVERY_NOTE_FULLY_LINKED: "DELIVERY_NOTE_FULLY_LINKED",
    DELIVERY_NOTE_DELETED: "DELIVERY_NOTE_DELETED",
}
